import {BigWinView} from '@fantasmagames/slot/src/modules/bigwin/BigWinView';
import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {BigWinBasicState} from '@fantasmagames/slot/src/modules/bigwin/states/BigWinBasicState';
import {BigWinPlayingState} from '@fantasmagames/slot/src/modules/bigwin/states/BigWinPlayingState';
import {BigWinFinalState} from '@fantasmagames/slot/src/modules/bigwin/states/BigWinFinalState';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';

export class BigWinModule extends Module<BigWinView> {
	public static readonly BASIC_STATE: string = 'basic';
	public static readonly PLAYING_STATE: string = 'playing';
	public static readonly FINAL_STATE: string = 'final';

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.BIG_WIN_VIEW_MOBILE);
		} else {
			this.setView(Views.BIG_WIN_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onViewCurrentStateHandle(BigWinView.METER_FINISHED);
		this.onViewCurrentStateHandle(BigWinView.SKIP_CLICKED);
		this.onViewCurrentStateHandle(BigWinView.END_ANIMATION_FINISHED);

		this.onCurrentStateHandle(FlowModuleEvents.WON_BIG_WIN);
		this.onViewEmitEvent(BigWinView.EXPLOSION_STARTED, BigWinEvents.EXPLOSION_STARTED);
		this.onViewEmitEvent(BigWinView.TRANSITION_STARTED, BigWinEvents.TRANSITION_STARTED);
		this.onViewEmitEvent(BigWinView.BIG_WIN_STARTED, BigWinEvents.BIG_WIN_STARTED);
		this.onViewEmitEvent(BigWinView.TRANSITION_ENDED, BigWinEvents.TRANSITION_ENDED);
	}

	protected setupStates(): void {
		this.addState(new BigWinBasicState(this, BigWinModule.BASIC_STATE));
		this.addState(new BigWinPlayingState(this, BigWinModule.PLAYING_STATE));
		this.addState(new BigWinFinalState(this, BigWinModule.FINAL_STATE));
	}

	protected enterFirstState(): void {
		this.changeStateTo(BigWinModule.BASIC_STATE);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/bigwin/BigWinModule.ts